export enum AssignmentPeopleContext {
  User = "user",
  Group = "group",
  TemplateGroup = "templateGroup"
}
